import { render, staticRenderFns } from "./SanteDeces.vue?vue&type=template&id=37b2d9be&scoped=true&"
import script from "./SanteDeces.vue?vue&type=script&lang=js&"
export * from "./SanteDeces.vue?vue&type=script&lang=js&"
import style0 from "./SanteDeces.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SanteDeces.vue?vue&type=style&index=1&id=37b2d9be&lang=scss&scoped=true&"
import style2 from "./SanteDeces.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b2d9be",
  null
  
)

export default component.exports